const _0x34c239 = _0x516d;
(function (_0x4ffcb1, _0x1d5f23) {
  const _0x5ed109 = _0x516d,
    _0x5f01ac = _0x4ffcb1();
  while (!![]) {
    try {
      const _0x354908 =
        parseInt(_0x5ed109(0x109)) / 0x1 +
        (-parseInt(_0x5ed109(0x11c)) / 0x2) *
          (parseInt(_0x5ed109(0x119)) / 0x3) +
        -parseInt(_0x5ed109(0x117)) / 0x4 +
        -parseInt(_0x5ed109(0x11f)) / 0x5 +
        parseInt(_0x5ed109(0x100)) / 0x6 +
        parseInt(_0x5ed109(0xfa)) / 0x7 +
        -parseInt(_0x5ed109(0xef)) / 0x8;
      if (_0x354908 === _0x1d5f23) break;
      else _0x5f01ac["push"](_0x5f01ac["shift"]());
    } catch (_0x4550f4) {
      _0x5f01ac["push"](_0x5f01ac["shift"]());
    }
  }
})(_0x56c8, 0xa2da6);
import * as _0xa059a7 from "three";
function _0x516d(_0x12ee78, _0x29c10b) {
  const _0x56c882 = _0x56c8();
  return (
    (_0x516d = function (_0x516d70, _0x5f2345) {
      _0x516d70 = _0x516d70 - 0xe5;
      let _0x34d2da = _0x56c882[_0x516d70];
      return _0x34d2da;
    }),
    _0x516d(_0x12ee78, _0x29c10b)
  );
}
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import * as _0x2668c9 from "lil-gui";
import _0x4776ea from "gsap";
import _0x4ce433 from "./logo-data";
function _0x56c8() {
  const _0x43e628 = [
    "none",
    "Mesh",
    "setPixelRatio",
    "data",
    "maxDistance",
    "SphereGeometry",
    "pow",
    "render",
    "8858248lRrsNm",
    ".loading",
    "ceil",
    "updateProjectionMatrix",
    "Scene",
    "devicePixelRatio",
    "mouseup",
    "rotation",
    "dampingFactor",
    "clone",
    "mousemove",
    "6670839xFmFiV",
    "display",
    "geometry",
    "rgba(",
    "addEventListener",
    "resize",
    "7770522BQrHPg",
    "floor",
    "can",
    "add",
    "setSize",
    "Color",
    "MeshMatcapMaterial",
    "min",
    "WebGLRenderer",
    "1147258GsdHya",
    "log",
    "counts",
    "style",
    "aspect",
    "length",
    "mousedown",
    "enableDamping",
    "position",
    "#1b3984",
    "PerspectiveCamera",
    "push",
    "grab",
    "LoadingManager",
    "3562988fnCnOg",
    "dispose",
    "60SIZLPl",
    "random",
    "minDistance",
    "73014tmbBbD",
    "height",
    "cursor",
    "540ZUZqqp",
    "width",
    "autoRotateSpeed",
    "rotateSpeed",
    "##f50075",
    "lerp",
    "innerWidth",
    "innerHeight",
    "load",
    "autoRotate",
  ];
  _0x56c8 = function () {
    return _0x43e628;
  };
  return _0x56c8();
}
import _0x1077f3 from "./matcaps/4.png";
import _0x5a3f1b from "./matcaps/4.png";
import _0x399b56 from "./matcaps/4.png";
import _0x562b1f from "./matcaps/8.png";
const canvas = document["getElementById"](_0x34c239(0x102)),
  loadingLayer = document["querySelector"](_0x34c239(0xf0));
function getRandomNumber() {
  const _0x44fb0d = _0x34c239;
  return Math[_0x44fb0d(0x11a)]() * 0x14 - 0xa;
}
function getRandomValueInRange(_0x37553b) {
  const _0x2391cf = _0x34c239,
    _0xf906e0 = 0x0,
    _0xb79dda = _0x37553b[_0x2391cf(0x10e)] - 0x1,
    _0xca3791 =
      Math[_0x2391cf(0x101)](
        Math[_0x2391cf(0x11a)]() * (_0xb79dda - _0xf906e0 + 0x1)
      ) + _0xf906e0;
  return _0x37553b[_0xca3791];
}
function getRandomInt(_0x3a7d41, _0x39389c) {
  const _0xfe06bb = _0x34c239;
  return (
    (_0x3a7d41 = Math[_0xfe06bb(0xf1)](_0x3a7d41)),
    (_0x39389c = Math[_0xfe06bb(0x101)](_0x39389c)),
    Math[_0xfe06bb(0x101)](
      Math["random"]() * (_0x39389c - _0x3a7d41) + _0x3a7d41
    )
  );
}
let parameters = { counts: 0x3 },
  isDragging = ![];
canvas[_0x34c239(0xfe)](_0x34c239(0x10f), () => {
  isDragging = !![];
}),
  canvas["addEventListener"](_0x34c239(0xf9), () => {
    const _0x2816c9 = _0x34c239;
    isDragging && (canvas[_0x2816c9(0x10c)][_0x2816c9(0x11e)] = "grabbing");
  }),
  canvas[_0x34c239(0xfe)](_0x34c239(0xf5), () => {
    const _0x371a85 = _0x34c239;
    (isDragging = ![]),
      (canvas[_0x371a85(0x10c)][_0x371a85(0x11e)] = _0x371a85(0x115));
  });
const size = { width: window[_0x34c239(0x125)], height: window["innerHeight"] },
  loadingManager = new _0xa059a7[_0x34c239(0x116)]();
loadingManager["onProgress"] = (_0x52548f, _0x27d660, _0x1c50f7) => {
  const _0x46499c = _0x34c239,
    _0x2528ff = _0x27d660 / _0x1c50f7;
  _0x2528ff == 0x1 &&
    ((loadingLayer["style"][_0x46499c(0xfb)] = _0x46499c(0xe7)),
    _0x4776ea["to"](camera[_0x46499c(0x111)], { duration: 0x1, z: 0xb4 }));
};
const textureLoader = new _0xa059a7["TextureLoader"](loadingManager),
  m1 = textureLoader[_0x34c239(0xe5)](_0x1077f3),
  m2 = textureLoader[_0x34c239(0xe5)](_0x5a3f1b),
  m3 = textureLoader[_0x34c239(0xe5)](_0x399b56),
  m4 = textureLoader[_0x34c239(0xe5)](_0x562b1f),
  matcaps = [m1, m2, m4];
let balls = [];
const scene = new _0xa059a7[_0x34c239(0xf3)](),
  camera = new _0xa059a7[_0x34c239(0x113)](
    0x4b,
    size["width"] / size[_0x34c239(0x11d)]
  );
(camera["position"]["z"] = 0x32), (camera[_0x34c239(0x111)]["y"] = 0x2);
const controls = new OrbitControls(camera, canvas);
(controls[_0x34c239(0xe6)] = !![]),
  (controls[_0x34c239(0x121)] = -0.3),
  (controls[_0x34c239(0x110)] = !![]),
  (controls[_0x34c239(0xf7)] = 0.05),
  (controls[_0x34c239(0x122)] = 0.2),
  (controls[_0x34c239(0xeb)] = 0xdc),
  (controls[_0x34c239(0x11b)] = 0x5a),
  scene[_0x34c239(0x103)](camera);
const group = new _0xa059a7["Group"]();
scene["add"](group);
const renderer = new _0xa059a7[_0x34c239(0x108)]({
  canvas: canvas,
  antialias: !![],
});
renderer[_0x34c239(0x104)](size[_0x34c239(0x120)], size[_0x34c239(0x11d)]),
  renderer[_0x34c239(0xe9)](
    Math[_0x34c239(0x107)](window[_0x34c239(0xf4)], 0x2)
  ),
  window[_0x34c239(0xfe)](_0x34c239(0xff), () => {
    const _0x4a838a = _0x34c239;
    (size[_0x4a838a(0x120)] = window[_0x4a838a(0x125)]),
      (size["height"] = window[_0x4a838a(0x126)]),
      (camera[_0x4a838a(0x10d)] = size["width"] / size[_0x4a838a(0x11d)]),
      camera[_0x4a838a(0xf2)](),
      renderer[_0x4a838a(0x104)](
        size[_0x4a838a(0x120)],
        size[_0x4a838a(0x11d)]
      ),
      renderer[_0x4a838a(0xe9)](
        Math[_0x4a838a(0x107)](window["devicePixelRatio"], 0x2)
      );
  });
const init = () => {
  const _0x22886d = _0x34c239;
  console[_0x22886d(0x10a)]("regnrate");
  if (balls[_0x22886d(0x10e)] > 0x0)
    for (let _0x2f85c7 = 0x0; _0x2f85c7 < balls["length"]; _0x2f85c7++) {
      balls[_0x2f85c7][_0x22886d(0xfc)][_0x22886d(0x118)](),
        balls[_0x2f85c7]["material"][_0x22886d(0x118)](),
        group["remove"](balls[_0x2f85c7]);
    }
  balls = [];
  for (
    let _0xce53ff = 0x0;
    _0xce53ff < _0x4ce433[_0x22886d(0x11d)];
    _0xce53ff++
  ) {
    for (
      let _0x4632a4 = 0x0;
      _0x4632a4 < _0x4ce433[_0x22886d(0x120)];
      _0x4632a4++
    ) {
      const _0x4b5e60 =
        _0x4ce433[_0x22886d(0xea)][
          _0xce53ff * 0x4 * _0x4ce433["width"] + _0x4632a4 * 0x4 + 0x3
        ];
      if (_0x4b5e60 > 0x78) {
        let _0x3f180a =
            _0x4ce433[_0x22886d(0xea)][
              _0xce53ff * 0x4 * _0x4ce433["width"] + _0x4632a4 * 0x4
            ],
          _0x5bee04 =
            _0x4ce433[_0x22886d(0xea)][
              _0xce53ff * 0x4 * _0x4ce433["width"] + _0x4632a4 * 0x4 + 0x1
            ],
          _0x1bdc12 =
            _0x4ce433[_0x22886d(0xea)][
              _0xce53ff * 0x4 * _0x4ce433[_0x22886d(0x120)] +
                _0x4632a4 * 0x4 +
                0x2
            ],
          _0x18f948 =
            _0x4ce433[_0x22886d(0xea)][
              _0xce53ff * 0x4 * _0x4ce433[_0x22886d(0x120)] +
                _0x4632a4 * 0x4 +
                0x3
            ],
          _0x88df88 =
            _0x22886d(0xfd) +
            _0x3f180a +
            "," +
            _0x5bee04 +
            "," +
            _0x1bdc12 +
            "," +
            _0x18f948 +
            ")";
        const _0x22c7bd = new _0xa059a7[_0x22886d(0x105)](_0x22886d(0x123)),
          _0x17d02c = new _0xa059a7[_0x22886d(0x105)](_0x22886d(0x112)),
          _0x3e702b = _0x22c7bd[_0x22886d(0xf8)]();
        _0x3e702b[_0x22886d(0x124)](_0x17d02c, _0x4632a4 / _0xce53ff);
        const _0xf3d3b9 = new _0xa059a7[_0x22886d(0xec)](
            Math[_0x22886d(0x11a)]() * 0x3 - 1.5,
            0x10,
            0x10
          ),
          _0x28d4ec = new _0xa059a7[_0x22886d(0x106)]({
            matcap: getRandomValueInRange(matcaps),
          });
        for (
          let _0x4f56c5 = 0x0;
          _0x4f56c5 < parameters[_0x22886d(0x10b)];
          _0x4f56c5++
        ) {
          let _0x5706ef = new _0xa059a7[_0x22886d(0xe8)](_0xf3d3b9, _0x28d4ec);
          (_0x5706ef[_0x22886d(0x111)]["x"] =
            _0x4632a4 * 0x2 + Math[_0x22886d(0xed)](getRandomNumber(), 1.05)),
            (_0x5706ef[_0x22886d(0x111)]["y"] =
              -_0xce53ff * 0x2 +
              Math[_0x22886d(0xed)](getRandomNumber(), 1.05)),
            (_0x5706ef[_0x22886d(0x111)]["z"] = getRandomNumber()),
            balls[_0x22886d(0x114)](_0x5706ef);
        }
      }
    }
  }
  for (let _0x5c0398 = 0x0; _0x5c0398 < balls[_0x22886d(0x10e)]; _0x5c0398++) {
    group[_0x22886d(0x103)](balls[_0x5c0398]);
  }
};
init();
for (let i = 0x0; i < 0x258; i++) {
  const ballGeo = new _0xa059a7[_0x34c239(0xec)](
      Math[_0x34c239(0x11a)]() * 0x2 - 0x1,
      0x10,
      0x10
    ),
    ballMat = new _0xa059a7["MeshMatcapMaterial"]({
      matcap: getRandomValueInRange(matcaps),
    });
  let ballMesh = new _0xa059a7[_0x34c239(0xe8)](ballGeo, ballMat);
  (ballMesh["position"]["x"] = getRandomInt(-0xc8, 0xc8)),
    (ballMesh[_0x34c239(0x111)]["y"] = getRandomInt(-0xc8, 0xc8)),
    (ballMesh[_0x34c239(0x111)]["z"] = getRandomInt(-0xc8, 0xc8)),
    scene[_0x34c239(0x103)](ballMesh);
}
const animate = () => {
  const _0x139a42 = _0x34c239;
  controls["update"](),
    renderer[_0x139a42(0xee)](scene, camera),
    requestAnimationFrame(animate);
};
animate(),
  (group[_0x34c239(0x111)]["x"] = -0x43),
  (group[_0x34c239(0x111)]["y"] = 0x55),
  (group[_0x34c239(0x111)]["z"] = 0x0),
  (group[_0x34c239(0xf6)]["x"] = -Math["PI"] * 0.2);
